import { ESTADO_LABEL, estadoTone } from '../lib/format';

export function StatusBadge({
  estado,
  syncStatus,
  local,
}: {
  estado: string;
  syncStatus?: 'queued' | 'synced' | 'error';
  local?: boolean;
}) {
  let label = ESTADO_LABEL[estado] ?? estado;
  let tone = estadoTone(estado);

  if (syncStatus === 'error') {
    label = 'Error de sync';
    tone = 'danger';
  } else if (local || syncStatus === 'queued') {
    label = 'En cola local';
    tone = 'warning';
  } else if (syncStatus === 'synced' && estado === 'en_cola') {
    label = 'Sincronizado';
    tone = 'success';
  }

  return (
    <span className={`status-badge status-badge--${tone}`}>
      <span className="status-badge__dot" aria-hidden="true" />
      {label}
    </span>
  );
}

export function VolumeBadge({ cajas }: { cajas: number }) {
  return (
    <span className="volume-badge">
      {new Intl.NumberFormat('es-VE', { maximumFractionDigits: 0 }).format(cajas)} Cjs
    </span>
  );
}

export function DataNotice({
  demo,
  offline,
  message,
}: {
  demo?: boolean;
  offline?: boolean;
  message?: string;
}) {
  if (!demo && !offline) return null;
  return (
    <div className={`data-notice${demo ? ' data-notice--demo' : ''}`} role="status">
      <span className="data-notice__dot" aria-hidden="true" />
      {message ??
        (demo
          ? 'Datos de demostración: los pedidos nuevos quedan en la cola local.'
          : 'Trabajando con datos guardados en el dispositivo. Se sincronizará al reconectar.')}
    </div>
  );
}
